import React, { useState, useEffect, useRef } from 'react';
import { Flex, IconClose } from '@adserve/adserve-react-components';
import { ReactComponent as IconChevronDown } from '../../../../svg/icon_chevron_down.svg';
import { labelStyle } from '../../../../styles';
import {
    dropDownTextStyle,
    chevronDownStyle,
    listContainerStyle,
    itemStyle
} from './DropdownStyles';
import DropdownItem from './DropdownItem';

const Dropdown = ({
    // ToDo: To be replaced with common dropdown when it is stable
    readOnly = false,
    id,
    name,
    title,
    value,
    values,
    onChange,
    style = { zIndex: 100 }
}) => {
    // Styles
    const dropDownStyle = {
        boxSizing: 'border-box',
        height: 37,
        userSelect: 'none',
        border: '1px solid #D7D7D7',
        borderRadius: 5,
        backgroundColor: readOnly ? '#F7F7F7' : '#fffdf4',
        padding: '5px 0px 0px 5px',
        display: 'flex',
        flexJustify: 'space-between',
        cursor: 'pointer',
        position: 'relative',
        ...style
    };

    // State
    const node = useRef();
    const [selectShowing, setSelectShowing] = useState(false);
    const [selectText, setSelectText] = useState('');

    useEffect(() => {
        if (value) {
            updateSelectText(value);
        }
    }, [values]);

    useEffect(() => {
        if (value) {
            updateSelectText(value);
        }
    }, [value]);

    const handleClose = () => {
        setSelectShowing(false);
    };

    const handleRightClick = (e) => {
        e.preventDefault();
    };

    const handleSelectItem = (e, stId) => {
        onChange(name, stId);
        updateSelectText(stId);
        setSelectShowing(!selectShowing);
    };

    const updateSelectText = (stId) => {
        const arr = values.filter((st) => {
            return st.id === stId;
        });
        if (arr.length) {
            let selectedText = arr[0].name;
            if (selectedText.length > 23) {
                selectedText = selectedText.substring(0, 20) + '...';
            }
            setSelectText(selectedText);
        }
    };

    const handleClickOutside = (e) => {
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        // outside click
        setSelectShowing(false);
    };

    useEffect(() => {
        if (selectShowing) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [selectShowing]);

    const SelectList = () => {
        return (
            <div
                style={{
                    ...listContainerStyle,
                    // width: style?.width - 2,
                    zIndex: style?.zIndex - 10,
                    overflowY: 'scroll',
                    height:500,
                    width: style?.width-2 ?? 229
                }}
                title=''
                onContextMenu={handleRightClick}
            >
                <Flex
                    style={{
                        flexDirection: 'column',
                        width: '100%',
                        height: '100%'
                    }}
                >
                    <Flex
                        style={{
                            height: '100%'
                        }}
                    >
                        <div
                            style={{
                                width: '100%',
                                position: 'relative',
                                padding: '0 1px',
                                overflowWrap: 'anywhere'
                            }}
                        >
                            <Flex
                                style={{
                                    width: '100%',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                <div
                                    style={{
                                        padding: '0 4px'
                                    }}
                                    onClick={handleClose}
                                >
                                    <IconClose
                                        style={{ cursor: 'pointer' }}
                                        height={14}
                                        width={14}
                                    />
                                </div>
                            </Flex>
                            {values.map((item, i) => {
                                return (
                                    <DropdownItem
                                        id={`${id}-selectItem-${i}`}
                                        key={`${id}-selectItem-${i}`}
                                        readOnly={readOnly}
                                        item={item}
                                        value={value}
                                        // backgroundColor={(i % 2) ? '#F7F7F7' : '#FFFFFF'}
                                        backgroundColor={'#FFFFFF'}
                                        onSelect={handleSelectItem}
                                    />
                                );
                            })}
                            <div style={itemStyle}>{/* &nbsp; */}</div>
                        </div>
                    </Flex>
                </Flex>
            </div>
        );
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <label style={labelStyle}>{title}</label>
            <div
                ref={node}
                style={{
                    display: Flex,
                    flexDirection: 'column',
                    marginTop: 1,
                    overflowY: 'hidden'
                }}
            >
                <div
                    id={id}
                    style={dropDownStyle}
                    onClick={() =>
                        !readOnly && setSelectShowing(!selectShowing)
                    }
                >
                    <table width='100%'>
                        {/* {' '} */}
                        <tbody>
                            <tr>
                                <td
                                    width='80%'
                                    style={{
                                        ...dropDownTextStyle,
                                        textAlign: 'left'
                                    }}
                                >
                                    {selectText}
                                    {/* {' '} */}
                                </td>
                                <td align='right'>
                                    <IconChevronDown style={chevronDownStyle} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {selectShowing && <SelectList />}
            </div>
        </div>
    );
};
export default Dropdown;
